<template>
	<div class="cenList">
		<template v-if="headerShow">
			<div class="cenListFor" v-for="(item,index) in list" :key="index">
				<div class="cenListForTile" v-if="item.label">
					{{item.label}}
				</div>
				<div class="cenListForCen">
					<div class="cenListForCenFor" v-for="(itema,indexa) in item.product_list" :key="indexa"
						@click="goDetail(itema)">
						<div class="cenListForCenForImg">
							<img :src="itema.cover">
						</div>
						<div class="cenListForCenForName">
							{{itema.name}}
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="cenListFor" v-for="(item,index) in list" :key="index">
				<div class="cenListForTile" v-if="item.label">
					<div class="h5_title">{{item.label}}</div>
				</div>
				<div class="cenListForCen">
					<div class="cenListForCenFor" v-for="(itema,indexa) in item.product_list" :key="indexa"
						@click="goDetail(itema)">
						<div class="cenListForCenForImg">
							<img :src="itema.cover">
						</div>
						<div class="cenListForCenForName">
							{{itema.name}}
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Array,
				default: []
			}

		},
		data() {
			return {

			}
		},
		mounted() {

		},
		methods: {
			goDetail(e) {
				console.log(e)
				this.$router.push({
					path: '/productDetail',
					name: 'productDetail',
					query: {
						id: e.id
					}
				})
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.cenList {
		width: 1200px;
		margin: 0 auto;

		.cenListFor {
			margin-bottom: 30px;

			.cenListForTile {
				font-size: 26px;
				font-family: Source Han Sans CN;
				// font-weight: 400;
				font-weight: 700;
				color: #000000;
				padding-bottom: 28px;
				margin-bottom: 69px;
				border-bottom: 2px solid #E5E5E5;
			}

			.cenListForCen {
				display: flex;
				flex-wrap: wrap;

				.cenListForCenFor:hover {
					// box-shadow: 0 4px 16px -4px rgba(0,0,0,0.1);
				}

				.cenListForCenFor:nth-of-type(3n-1) {
					margin: 0 2%;
					margin-bottom: 30px;
				}

				.cenListForCenFor {
					width: 32%;
					margin-bottom: 30px;
					transition: all linear 0.3s;
					cursor: pointer;

					.cenListForCenForImg {
						overflow: hidden;
						width: 100%;
						height: 260px;

						img {
							width: 100%;
							object-fit: contain;
							transition: all 0.3s ease-in-out;
						}
					}

					.cenListForCenForName {
						// font-size: 22px;
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #000000;
						margin: 32px 0px;
						text-align: center;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
			}
		}
	}
	
	
	@media screen and (max-width:1200px) {
		.cenList {
			width: 100% !important;
			overflow: hidden;
			.cenListFor{
				// background-color: greenyellow;
				// padding: 0 30px;
				box-sizing: border-box;
				margin-bottom: 0px !important;
				.cenListForTile{
					// padding: 0 30px;
					box-sizing: border-box;
					font-size: 20px !important;
					margin-bottom: 10px !important;
					padding-bottom: 10px !important;
					.h5_title{
						padding:0 30px;
						box-sizing: border-box;
					}
				}
				.cenListForCen{
					width: 100% !important;
					display: block;
					padding: 0 30px !important;
					box-sizing: border-box !important; 
					.cenListForCenFor{
						width: 100%;
						margin: 0 !important;
						// background-color: pink;
					}
				}
			}
		}
	}
</style>